import { ISettingsButtonProps } from "@/Common/Components/Settings/SettingsButton";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IRefreshButtonProps {
    onClickOperation?: number;
    onClick?: () => void;
    className?: string;
    rightMargin?: number;
    isDisabled?: boolean;
}

class RefreshButtonState {
}

class RefreshButton extends React.Component<IRefreshButtonProps, RefreshButtonState> {
    public render(): JSX.Element {
        var self = this;
        var marginStyle = null;
        if (this.props.rightMargin != null) {
            if (this.props.rightMargin >= 0) {
                marginStyle = {
                    marginRight: self.props.rightMargin
                };
            }
        }

        return (
            <button disabled={this.props.isDisabled} className={this.props.className + " button control"} style={marginStyle} onClick={this.handleClick.bind(this)}>
                <i className="fi-refresh" data-cy="fi-refresh">&nbsp;</i>
            </button>
        );
    }

    public handleClick(event: React.MouseEvent): void {
        event.stopPropagation();

        if (this.props.onClickOperation != null)
            LocalEvent.Dispatch(this.props.onClickOperation);

        if (this.props.onClick != null)
            this.props.onClick();
    }

    public componentWillUpdate(nextProps: ISettingsButtonProps): boolean {
        return nextProps.onClickOperation != this.props.onClickOperation;
    }
}

export { RefreshButton };
